import React, { createContext, useReducer } from "react";
import routes from "../../routes";

export const UPDATE_STEP = "UPDATE_STEP";
export const SHOW_PROGRESS_BAR = "SHOW_PROGRESS_BAR";
export const CURRENT_STEP = "CURRENT_STEP";
export const SET_STEP = "SET_STEP";

export const INACTIVE = "inActive";
export const ACTIVE = "active";
export const COMPLETED = "completed";

export const SPSTEPS = [
  {
    name: "Your info",
    substeps: [routes.applicantInfo],
    totalSteps: 1,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  },
  {
    name: "Company info",
    substeps: [routes.companyInfo],
    totalSteps: 1,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  },
  {
    name: "Verification",
    substeps: [
      routes.stakeholdersInfo,
      routes.stakeholdersPreview,
      routes.StakeholderTermsAndConditions
    ],
    totalSteps: 3,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  },
  {
    name: "Business details",
    substeps: [
      routes.additionalInfoComponent,
      routes.additionalCompanyInformation,
      routes.additionalInfoComponent,
      routes.additionalStakeholderInformation,
      routes.additionalInfoComponent
    ],
    totalSteps: 5,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  },
  {
    name: "Options",
    substeps: [routes.accountServices],
    totalSteps: 1,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  },
  {
    name: "Submit",
    substeps: [routes.reviewAndSubmit],
    totalSteps: 1,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  }
];

export const OTHERSSTEPS = [
  {
    name: "Company details",
    substeps: [routes.applicantInfo, routes.companyInfo],
    totalSteps: 2,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  },
  {
    name: "Shareholders details",
    substeps: [routes.patnershipDetails, routes.patnerDetails, routes.partnersSummary],
    totalSteps: 3,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  },
  {
    name: "Verification",
    substeps: [
      routes.stakeholdersInfo,
      routes.stakeholdersPreview,
      routes.StakeholderTermsAndConditions
    ],
    totalSteps: 3,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  },
  {
    name: "Business details",
    substeps: [
      routes.additionalInfoComponent,
      routes.additionalCompanyInformation,
      routes.additionalInfoComponent,
      routes.additionalStakeholderInformation,
      routes.additionalInfoComponent
    ],
    totalSteps: 5,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  },
  {
    name: "Options",
    substeps: [routes.accountServices],
    totalSteps: 1,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  },
  {
    name: "Submit",
    substeps: [routes.reviewAndSubmit],
    totalSteps: 1,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  }
];

export const NONSIGNATORY_WITHOUT_EFR_STEPS = [
  {
    name: "Company details",
    substeps: [routes.applicantInfo, routes.companyInfo],
    totalSteps: 2,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  },
  {
    name: "Shareholders details",
    substeps: [routes.patnershipDetails, routes.patnerDetails, routes.partnersSummary],
    totalSteps: 3,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  },
  {
    name: "Business details",
    substeps: [routes.additionalStakeholderInformation],
    totalSteps: 5,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  },
  {
    name: "Submit",
    substeps: [routes.reviewAndSubmit],
    totalSteps: 1,
    status: INACTIVE,
    value: null,
    subStepIndex: 0
  }
];

export const STEP_TYPE = {
  SP: SPSTEPS,
  SPLL: SPSTEPS,
  MP: OTHERSSTEPS,
  MPLL: OTHERSSTEPS
};

const ProgressBarContext = createContext();

export const initialState = {
  steps: SPSTEPS,
  showProgressBar: -1,
  currentStepName: null,
  persona: null
};

const isMPPersonaType = persona => persona === "MP" || persona === "MPLL";

const removeOptionsStep = steps => steps.filter(step => step.name !== "Options");

const mergeStepProperties = steps =>
  steps.map((step, index) => ({
    ...steps[index],
    ...step
  }));

export const reducer = (state, action) => {
  switch (action.type) {
    case SET_STEP: {
      const { persona, isNonSignatoryWithoutEFRJourney, isNonSignatoryJourney } = action.payload;

      const newSteps = isNonSignatoryWithoutEFRJourney
        ? NONSIGNATORY_WITHOUT_EFR_STEPS
        : STEP_TYPE[persona];

      if (!newSteps) {
        return state;
      }
      if (
        !isNonSignatoryJourney &&
        ((state.persona === "MP" && persona === "MPLL") ||
          (state.persona === "MPLL" && persona === "MP") ||
          state.persona === persona)
      ) {
        return { ...state, steps: STEP_TYPE[persona] };
      }
      if (isMPPersonaType(persona) || isMPPersonaType(state.persona)) {
        if (isNonSignatoryJourney) {
          //remove Options step
          return {
            ...state,
            steps: removeOptionsStep(newSteps)
          };
        } else {
          return {
            ...state,
            steps: newSteps,
            persona: action.payload.persona
          };
        }
      } else {
        return {
          ...state,
          steps: mergeStepProperties(newSteps)
        };
      }
    }
    case UPDATE_STEP: {
      const updatedSteps = state?.steps?.map((step, index) => {
        if (index === action.payload.index) {
          return {
            ...step,
            value: action.payload.value,
            status: action.payload.status,
            subStepIndex: action.payload.subStepIndex
          };
        }
        return step;
      });
      return {
        ...state,
        steps: [...updatedSteps]
      };
    }
    case SHOW_PROGRESS_BAR:
      return {
        ...state,
        showProgressBar: action.payload
      };
    case CURRENT_STEP:
      return {
        ...state,
        currentStepName: action.payload
      };
    default:
      return state;
  }
};

const ProgressBarProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <ProgressBarContext.Provider value={{ state, dispatch }}>
      {children}
    </ProgressBarContext.Provider>
  );
};

export { ProgressBarProvider, ProgressBarContext };
